import { SVGProps } from "react";

// eslint-disable-next-line import/prefer-default-export
export const GameIconsCook = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 512 512"
      {...props}
    >
      <path
        fill="currentColor"
        /* eslint-disable-next-line max-len */
        d="M255 22.31c-21.2 0-40.5 10.78-50.5 27.63l-4.4 7.42l-7.6-4.08c-7.1-3.85-15.2-5.89-23.3-5.89c-28.3 0-51.3 23.57-51.3 53.21c0 26.5 18.6 48.6 43.5 52.6l7.6 1.2v53.4c57.9-11.1 116-11.6 174 0v-69.7l4.8-2.6c15.7-8.3 26.1-26.1 26.1-46.15c0-28.8-20.7-51.12-45.4-51.12c-6.5 0-13 1.61-18.9 4.72l-6.2 3.2l-4.6-5.09C288 29.29 272 22.31 255 22.31m1 194.79c-25.6 0-51.1 2.4-76.7 7c-.9 6-1.3 12.2-1.3 18.6c0 29 9.2 55.2 23.6 73.7s33.5 29.3 54.4 29.3s40-10.8 54.4-29.3s23.6-44.7 23.6-73.7c0-6.4-.5-12.7-1.3-18.7c-25.6-4.7-51.1-7-76.7-6.9M208.7 348l-89.2 29.7l-27.98 112H321.6L307.1 388l17.8-2.6l14.9 104.3h80.7l-28-112l-89.2-29.7c-13.8 9.9-30 15.7-47.3 15.7s-33.5-5.8-47.3-15.7m69.3 52.7a10 10 0 0 1 10 10a10 10 0 0 1-10 10a10 10 0 0 1-10-10a10 10 0 0 1 10-10m7 46a10 10 0 0 1 10 10a10 10 0 0 1-10 10a10 10 0 0 1-10-10a10 10 0 0 1 10-10"
      />
    </svg>
  );
};
